import { navigate } from "gatsby";
import React, { FC, PropsWithChildren } from "react";
import siteConfig from "../config/siteConfig";
import { hasConsentedDisclaimer } from "../services/disclaimerService";
import { isBrowser } from "../utilities/isBrowser";
import { mapLanguageToUrlSegment } from "../utilities/routes/urlLanguageMapper";
import { compareLanguages } from "../utilities/routes/utilities";

export interface DisclaimerRouteProps {
    lang?: string;
}

export const DisclaimerRoute: FC<PropsWithChildren<DisclaimerRouteProps>> = ({ lang, children }) => {
    if (!isBrowser()) {
        return null;
    }

    let currentLang = lang;

    if (!currentLang?.length) {
        currentLang = "en";
    }

    const disclaimerRoute = compareLanguages(currentLang, siteConfig.baseLang) === false
        ? `/${mapLanguageToUrlSegment(currentLang)}/disclaimer`
        : "/disclaimer";

    if (!hasConsentedDisclaimer() && window.location.pathname.indexOf(disclaimerRoute) === -1) {
        navigate(`${disclaimerRoute}?returnUrl=${encodeURIComponent(window.location.pathname)}`);
        return null;
    }

    return <>{children}</>;
};